import type { PluginDefinition } from "@magic-md/core";

/**
 * Local parsing deliberately keeps an external config lightweight. Once the
 * Engine projection arrives, replace only that persistence placeholder with
 * the hydrated definition while preserving fail-closed metadata on errors.
 */
export function mergeHydratedExternalConfigDefinition(
    local: PluginDefinition,
    engine: PluginDefinition,
): PluginDefinition | null {
    if (!local.externalConfigRef) return null;
    const { output: _output, ...engineWithoutOutput } = engine;
    return {
        ...local,
        ...engineWithoutOutput,
        externalConfigRef: engine.configExternalError
            ? local.externalConfigRef
            : undefined,
    };
}
